import { useState, useEffect, useMemo } from 'react';

const THEME_KEY = 'user-theme-preference';

export function useTheme() {
  const getSystemTheme = () => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  };

  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem(THEME_KEY);
    if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark' || savedTheme === 'auto')) {
      return savedTheme;
    }
    return 'auto';
  };

  const [themeMode, setThemeMode] = useState(getInitialTheme);

  const effectiveTheme = useMemo(() => {
    return themeMode === 'auto' ? getSystemTheme() : themeMode;
  }, [themeMode]);

  const applyTheme = (theme) => {
    const root = document.documentElement;
    const appliedTheme = theme === 'auto' ? getSystemTheme() : theme;
    root.setAttribute('data-theme', appliedTheme);
  };

  const setTheme = (newTheme) => {
    setThemeMode(newTheme);
    localStorage.setItem(THEME_KEY, newTheme);
    applyTheme(newTheme);
  };

  const toggleTheme = () => {
    const currentTheme = effectiveTheme;
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
  };

  useEffect(() => {
    applyTheme(themeMode);

    // Observar mudanças na preferência do sistema
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      if (themeMode === 'auto') {
        applyTheme('auto');
      }
    };
    
    mediaQuery.addEventListener('change', handleChange);
    
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [themeMode]);

  return {
    themeMode,
    effectiveTheme,
    setTheme,
    toggleTheme
  };
}
